import { Navigate } from "react-router-dom";
import { SignolUtils } from "@src/utils";
import { OperatorContainer } from "@src/pages/operator/operatorContainer";
import {
  OverviewPage as OperatorOverviewPage,
  ImpactPage as OperatorImpactPage,
  GoalsPage as OperatorGoalsPage,
  NotificationsPage as OperatorNotificationsPage,
  ProfilePage as OperatorProfilePage,
  SelfReportingPage as OperatorSelfReportingPage,
  SupportPage as OperatorSupportPage,
  EventsPage as OperatorEventsPage,
  EventDetailsPage as OperatorEventDetailsPage,
} from "@src/pages/operator/index";
import { operatorLoader } from "../loaders/index";
import Protected from "./Protected";

const operatorRootLoader = async (req) => {
  return {
    // dict of promises so we can display loading screen
    initialData: operatorLoader(req), // required
    //nonCriticalData: ...
  };
};

/** @type {import("react-router").RouteObject} */
export const operatorRoutes = {
  path: "operator",
  loader: operatorRootLoader,
  element: (
    <Protected allowedUserType={"operator"}>
      <OperatorContainer />
    </Protected>
  ),
  children: [
    {
      index: true,
      element: <Navigate to="overview" />,
    },
    {
      path: "overview",
      menuIcon: "chartColumnOutline",
      menuIconActive: "chartColumnFilled",
      pageTitle: "Overview",
      element: <OperatorOverviewPage />,
    },
    {
      path: "goals",
      menuIcon: "goalOutline",
      menuIconActive: "goalFilled",
      pageTitle: "Goals",
      element: <OperatorGoalsPage />,
    },
    {
      path: "events",
      menuIcon: "calendarOutline",
      menuIconActive: "calendarFilled",
      pageTitle:
        SignolUtils.getIndustry() === "aviation" ? "Flight History" : "History",
      pageTitleFromDynamicContent: "captain__events__table_history_title",
      element: <OperatorEventsPage />,
    },
    {
      path: "impact",
      menuIcon: "leafCircleOutline",
      menuIconActive: "leafCircleFilled",
      pageTitle: "Impact",
      element: <OperatorImpactPage />,
    },
    {
      path: "notifications",
      menuIcon: "bellOutline",
      menuIconActive: "bellFilled",
      pageTitle: "Notifications",
      element: <OperatorNotificationsPage />,
    },
    {
      path: "support",
      menuIcon: "questionBlobOutline",
      menuIconActive: "questionBlobFilled",
      pageTitle: "Support",
      element: <OperatorSupportPage />,
    },
    {
      path: "profile",
      element: <OperatorProfilePage />,
    },
    {
      path: "selfreporting",
      element: <OperatorSelfReportingPage />,
    },
    {
      path: "events/:eventId",
      element: <OperatorEventDetailsPage />,
    },
    {
      path: "*",
      element: <Navigate to="/dashboard/operator" replace />, // error handle for 404 not found page  (<CustomRedirectWithMessage to="/operator/dashboard" />)
    },
  ],
};
